module.exports = __webpack_public_path__ + "static/media/image_18.c580dc9d.png";